import styled from "styled-components";

export const StepsProgress = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
`;

export const ProgressBarStep = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;

  &:last-child {
    width: max-content;
  }

  svg {
    width: 25px;
    height: 25px;
    color: var(--color-success);
  }

  div {
    width: 24px;
    height: 24px;
    border: 1px solid var(--theme-color-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3em;
    font-size: 12px;
    font-weight: 700;
    color: var(--theme-color-primary);

    &.active-step {
      background-color: var(--theme-color-primary);
      color: var(--theme-color-white);
    }
  }

  p {
    font-size: 14px;
    color: var(--text-color-primary);
    margin: 0;

    @media only screen and (max-width: 1023px) {
      font-size: 12px;
    }

    @media only screen and (max-width: 500px) {
      display: none;
    }
  }

  &:not(:last-child)::after {
    content: '';
    flex: 1;
    height: 2px;
    background-color: var(--border-color);
    border-radius: 1em;
  }
`;